module.exports = "/images/tick.svg?91c1615fffe59bf820bfeaa17d7faf35";